/**
 * Sanitizes image URLs to only allow https: and data: protocols
 */
export function sanitizeImageUrl(url) {
    if (url) {
        if (/^(https|data):/i.test(url)) {
            return url;
        }
    }
    return '';
}
//# sourceMappingURL=utils.js.map